import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../auth.service'; // 追加

@Component({
    selector: 'app-team-memo',
    templateUrl: './team-memo.component.html',
    styleUrls: ['./team-memo.component.scss']
})
export class TeamMemoComponent implements OnInit {
    memoContent: string = '';
    private memoKey = 'team'; // DB保存用キー

    constructor(
        private snackBar: MatSnackBar,
        private authService: AuthService // 追加
    ) { }

    ngOnInit(): void {
        // APIから取得
        this.authService.getMemo(this.memoKey).subscribe({
            next: (res) => {
                if (res && res.content) {
                    this.memoContent = res.content;
                }
            },
            error: (err) => {
                console.error('Failed to load memo', err);
            }
        });
    }

    saveMemo(): void {
        this.authService.saveMemo(this.memoKey, this.memoContent).subscribe({
            next: () => {
                this.snackBar.open('保存しました (DB)', 'Close', { duration: 2000 });
            },
            error: (err) => {
                console.error('Failed to save memo', err);
                this.snackBar.open('保存に失敗しました', 'Close', { duration: 3000 });
            }
        });
    }
}